// Decodes the claims out of a Google ID token. Authorization-code responses carry
// no claims at all, so this returns {} for them and the caller is expected to fall
// back to the user the API resolved from the code.
const getBasicProfile = (googleUser) => {
  if (!googleUser || !googleUser.credential) return {};

  try {
    return JSON.parse(atob(googleUser.credential.split('.')[1]));
  } catch (error) {
    console.error('Failed to decode Google credential:', error);
    return {};
  }
};

export default {
  getBasicProfile
};
